import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const tutorSessionApi = createApi({
  reducerPath: 'tutorSessionApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    cancelSession: builder.mutation({
      query: ({SessionBookingId}) => ({
        url: `/WebTutor/CancelSlotSession`,
        method: "Post",
        params: {sessionBookingId: SessionBookingId}
      }),
    }),
    rescheduleSession: builder.mutation({
      query: (credentials) => ({
        url: `/WebTutor/RescheduleSlotSession`,
        method: "Post",
        body: credentials
      }),
    }),
  }),
});

export const {
  useCancelSessionMutation,
  useRescheduleSessionMutation
} = tutorSessionApi;